// extracted by mini-css-extract-plugin
export default {"spinner":"xMt9SITiBMQtgMFhkLMK","spin":"MxNf92w28whP0e6wLdHr"};